import type { DataBindingComponentModel } from '@wix/data-binding-registry-sdk'
import { FieldType } from '@wix/wix-data-schema-types'

export const mobilePicker: DataBindingComponentModel = {
  panel: {
    height: 576,
    title: 'mobui_MobuiPicker_dataBinding_panelTitle',
    helpId: '',
  },
  isConnectGfppEnabled: true,
  sections: [
    {
      role: 'MobuiPickerRole',
      genericRole: 'inputValue',
      bindings: [
        {
          title: 'mobui_MobuiPicker_dataBinding_value_label',
          prop: 'value',
          supportedFieldTypes: [FieldType.text],
          defaultFieldType: FieldType.text,
        },
      ],
    },
    {
      role: 'MobuiPickerOptionsRole',
      genericRole: 'inputValueOptions',
      bindings: [
        {
          title: 'mobui_MobuiPicker_dataBinding_options_label',
          prop: 'options',
          supportedFieldTypes: [FieldType.text],
          defaultFieldType: FieldType.text,
          requiresPrimaryConnection: true,
        },
      ],
      manifest: {
        gfpp: {
          desktop: {
            mainAction1: {
              actionId: 'manage',
              label: 'mobui_MobuiPicker_dataBinding_gfpp_manage',
            },
          },
        },
      },
      manageContentPanel: {
        description: 'mobui_MobuiPicker_dataBinding_gfpp_manage_description',
      },
    },
  ],
  compactErrorPanel: true,
}
